import React, { useState, useEffect } from 'react';
import { Shield, Award, Palette, Heart } from 'lucide-react';
import { businessInfo, features } from '../shopData';
import Ornament from './Ornament';

const iconMap = {
  Shield: Shield,
  Award: Award,
  Palette: Palette,
  Heart: Heart
};

const slides = [
  { src: '/products/about-slide-1.png', alt: 'Shri Kothari Jewellers — SKJ logo' },
  { src: '/products/about-slide-2.png', alt: 'Shri Kothari Jewellers — showroom & team' }
];

const About = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setActive((i) => (i + 1) % slides.length), 4000);
    return () => clearInterval(id);
  }, []);

  return (
    <section id="about" className="lux-section about-section-lux">
      <div className="lux-container">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Image Side — auto-sliding carousel */}
          <div className="relative">
            <div className="heritage-text-above mb-6">
              <div className="heritage-number">39 Years</div>
              <div className="heritage-subtext">of Trust & Excellence</div>
            </div>

            <div className="about-slider" data-testid="about-slider">
              {slides.map((s, i) => (
                <img
                  key={s.src}
                  src={s.src}
                  alt={s.alt}
                  className={`about-slide${i === active ? ' is-active' : ''}`}
                  loading={i === 0 ? 'eager' : 'lazy'}
                />
              ))}

              {/* Indicator dots */}
              <div className="about-slider-dots" aria-hidden="true">
                {slides.map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`about-slider-dot${i === active ? ' is-active' : ''}`}
                    onClick={() => setActive(i)}
                    data-testid={`about-slider-dot-${i}`}
                    aria-label={`Slide ${i + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <div className="lux-eyebrow">Our Story</div>
            <h2 className="lux-title" style={{ textAlign: 'left', margin: '0 0 1.25rem' }}>
              A Legacy of Silver Excellence
            </h2>
            <p className="about-section-desc">{businessInfo.description}</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-8">
              {features.map((feature, index) => {
                const IconComponent = iconMap[feature.icon];
                return (
                  <div key={index} className="feature-card" data-testid={`about-feature-${index}`}>
                    <div className="feature-icon">
                      <IconComponent size={22} />
                    </div>
                    <h3 className="feature-title">{feature.title}</h3>
                    <p className="feature-description">{feature.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div style={{ marginTop: '3rem' }}>
          <Ornament />
        </div>
      </div>
    </section>
  );
};

export default About;
